import store from '@/store/store'

class CacheModule {
  setCache(path, cache) {
    store.commit('CACHE_SET', { path, cache })
  }

  resetCaches() {
    store.commit('CACHES_RESET')
  }

  getCaches(path) {
    return store.state.caches[path]
  }
}

export default new CacheModule()
